import {ReactNode} from 'react';
import {InfinityScroll} from '../../../../../design-system/atoms/InfinityScroll/InfinityScroll';
import {Loading} from '../../../../../design-system/atoms/Loading/Loading';
import {useInfiniteMyCommentListQuery} from '../../../../../wrapper';

export function MyCommentListInfiniteFetcher({
  children,
}: {
  children: ReactNode;
}) {
  const {isLoading, data, hasNextPage, fetchNextPage, isFetching} =
    useInfiniteMyCommentListQuery(
      {page: 0},
      {
        initialPageParam: {page: 0},
        getNextPageParam: (lastPage, pages) => {
          return lastPage.myCommentList?.isEnd
            ? undefined
            : {page: pages.length};
        },
      }
    );

  if (isLoading) {
    return (
      <div className="flex-center-full">
        <Loading />
      </div>
    );
  }
  if (data) {
    return (
      <InfinityScroll
        isLoading={isFetching}
        canLoadNextPage={hasNextPage}
        requestNextPageData={fetchNextPage}
      >
        {children}
        {isFetching && (
          <div className="flex-center-full">
            <Loading />
          </div>
        )}
      </InfinityScroll>
    );
  }
  return null;
}
